import React, { useState, useEffect } from 'react'
import { Combo } from 'components'
import { fetchUrl } from 'modules/util/functions'

const EmbalajeCombo = (props) => {
	const [items, setItems] = useState([]);

	useEffect(() => {
		fetchUrl("/query/getEmbalajes", "get", {}, {
			success: (r) => {
				let items = r.data.embalajes.map(x => ({
					value: x.idEmbalaje,
					label: x.nombre
				}));

				if (props.exclusions)
					items = items.filter(x => !props.exclusions.includes(x.value.toString()));

				setItems(items);
			}
		}, { block: false });
	}, [props.exclusions]);

	return (
		<Combo
			{...props}
			items={items} />
	)
}

export default EmbalajeCombo;

EmbalajeCombo.defaultProps = {
	formControl: true,
	formManaged: false
};